export type PaidFilter = "all" | "paid" | "unpaid";

export interface StudentsTableState {
  selectedFields: string[];
  search: string;
  paidFilter: PaidFilter;
  selectedSetName: string;
}

const storageKey = (courseId: number) => `student_table_state_${courseId}`;

const isPaidFilter = (value: unknown): value is PaidFilter =>
  value === "all" || value === "paid" || value === "unpaid";

export const loadTableState = (courseId: number): StudentsTableState | null => {
  const raw = localStorage.getItem(storageKey(courseId));
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed.selectedFields)) return null;
    return {
      selectedFields: parsed.selectedFields,
      search: typeof parsed.search === "string" ? parsed.search : "",
      paidFilter: isPaidFilter(parsed.paidFilter) ? parsed.paidFilter : "all",
      selectedSetName: typeof parsed.selectedSetName === "string" ? parsed.selectedSetName : "",
    };
  } catch {
    return null;
  }
};

export const saveTableState = (courseId: number, state: StudentsTableState): void => {
  localStorage.setItem(storageKey(courseId), JSON.stringify(state));
};
